import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import ListItemView from './ListItemView';
import SelectInterventionPanel from './selectInterventionPanel';

function ListItemContainer({project}) {
  const history = useHistory();
  const [isPanelOpen, setIsPanelOpen] = React.useState(false);

  function handleClickProject() {
    if (project.interventions.length > 1) {
      setIsPanelOpen(true);
    } else {
      history.push(`/project/${project.projectId}/intervention/${project.interventions[0].id}`);
    }
  }

  return (
    <>
      <ListItemView
        project={project}
        onClickProject={handleClickProject}
      />
      <SelectInterventionPanel
        isOpen={isPanelOpen}
        project={project}
        onClose={() => setIsPanelOpen(false)}
      />
    </>
  );
}

ListItemContainer.propTypes = {
  project: PropTypes.object.isRequired
};

export default ListItemContainer;
